import { render, staticRenderFns } from "./QHSE.vue?vue&type=template&id=a94bbba0&scoped=true&"
import script from "./QHSE.vue?vue&type=script&lang=js&"
export * from "./QHSE.vue?vue&type=script&lang=js&"
import style0 from "./QHSE.vue?vue&type=style&index=0&id=a94bbba0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94bbba0",
  null
  
)

export default component.exports